import { render, staticRenderFns } from "./geoposicion.vue?vue&type=template&id=5d5e35de"
import script from "./geoposicion.vue?vue&type=script&lang=js"
export * from "./geoposicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports